module.exports = __webpack_public_path__ + "static/media/back.d3031093.jpeg";